import styled from 'styled-components/macro';

import TextBase from '@components/common/core/DataDisplay/Text';
import ButtonBase from '@components/common/core/Inputs/Button';
import SideModalBase from '@components/common/core/DataDisplay/SideModal';

export const SideModal = styled(SideModalBase)``;

export const SolveButton = styled(ButtonBase)`
  margin: 16px 32px;
  margin-left: auto;
`;

export const OrdersWrapper = styled.div`
  max-height: 208px;
  overflow-y: scroll;
  overflow-x: scroll;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray[5]};

  ::-webkit-scrollbar {
    width: 4px;
    position: absolute;
  }

  ::-webkit-scrollbar:horizontal {
    height: 0;
    width: 4px;
    position: absolute;
  }

  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.gray[4]};
    position: absolute;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.gray[1]};
    border-radius: 25px;
    transition: all 0.3s;
  }

  ::-webkit-scrollbar-thumb:horizontal {
    height: 1px;
    background-color: ${({ theme }) => theme.colors.gray[1]};
    border-radius: 25px;
    transition: all 0.3s;
  }

  ::-webkit-scrollbar-thumb:hover {
    opacity: brightness(0.8);
  }

  & > div > div > div:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray[5]};
  }
`;

export const Description = styled(TextBase)`
  line-height: 120%;
  color: ${({ theme }) => theme.colors.gray[2]};
`;

export const Title = styled(TextBase)`
  line-height: 120%;
  color: #ffffff;
`;

export const Header = styled.div`
  background-color: ${({ theme }) => theme.colors.gray[5]};
  padding: 12px 28px;
  display: flex;
  flex-direction: column;
`;

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.gray[6]};
  border-radius: 7px;
  overflow: hidden;
`;
